import { combineReducers } from 'redux';

import venueProfile from './venue-profile';
import errors from './errors';
import venueManagement from './venue-management';
import landingPageData from './landingPages';
import barnVenue from './barnVenue';
import allStylesLandingPageData from './all-styles-landing-page';
import massInquiryVenuesData from './mass-inquiry';

import { inquiryModalReducers } from '@weddingspot/ws-core-components';

let reducers = {
    errors,
    venueProfile,
    landingPageData,
    barnVenue,
    allStylesLandingPageData,
    massInquiryVenuesData,
    venueManagement,
    ...inquiryModalReducers,
};

export default combineReducers(reducers);
